import { BaseRouting } from '@aipb/routing';
import { Injectable } from '@angular/core';
import { ConfigViewerEnvService } from '../env/config-viewer-env.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigViewerRouting extends BaseRouting {
  static APP_ROUTE = 'config-viewer';
  static configPath = ':configId';
  static detailPath = 'detail';
  static detailNamePath = ':name';
  static detailIdPath = ':id';

  detail = this.createRouteSet<{
    name: string;
    id: string;
    configId?: string;
  }>([ConfigViewerRouting.detailPath, ConfigViewerRouting.detailNamePath, ConfigViewerRouting.detailIdPath]);

  constructor(configViewerEnv: ConfigViewerEnvService) {
    super(['/' + ConfigViewerRouting.APP_ROUTE, ConfigViewerRouting.configPath], configViewerEnv);
  }
}
